module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', [_c('myInfo', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "certNo": _vm.certNo
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large",
      "type": "info"
    },
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("补偿申请")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-206e46ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/myOrderInfo.vue
// module id = 469
// module chunks = 1